module.exports = __webpack_public_path__ + "public/images/Testimonial_Amy.60935aa4b52c4cc68579091bc9e128ae.webp";